import { countryRoutes } from '../../../constants/pickerRegions/regions'
import type { SupportedAlpha2CountryCode } from './getSupportedAlpha2CountryCodes'

export const toAlpha3 = (alpha2: SupportedAlpha2CountryCode) =>
  countryRoutes[alpha2]
